import React, { useEffect, useState } from 'react';
import {
  ButtonToolbar,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import format from 'date-fns/format';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import Select from '../../../shared/components/form/Select';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import TimetableGrid from './TimetableGrid';
import { ACTION_NAME, ACTIVE_TAB } from '../../../shared/utils/constants';
import MaterialTable from '../../../shared/components/material-table';
import enrollmentsColumns from './EnrollmentsColumns';
import DateField from '../../../shared/components/form/DateField';
import SmartButton from '../../../shared/components/SmartButton';
import { getDateWithoutTime } from '../../../shared/utils/smartutils';
import UnEnrollmentModal from '../../../shared/components/Modal';

const SchoolClassForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    initialize,
    schoolTerms,
    activeEmployeesList,
    stepsByCourse,
    relationStudentClassList,
    dto,
    loadStudentsToRelate,
    dispatch,
    changeRelationStudentClassList,
    courses,
    shifts,
    loadAllAcademicCalendar,
    academicCalendars,
    activeTab,
    toggleTab,
    disciplinesTimetable,
    timetable,
    loadTimetableBySchoolClass,
    setRegisteredStudents,
    registeredStudents,
    setSelectedAcademicCalendar,
    selectedAcademicCalendar,
    setSelectedClassShift,
    selectedClassShift,
    timetableGrid,
    setTimetableGrid,
  } = props;
  const [initialDateInMilli, setInitialDateInMilli] = useState(
    dto.term && new Date().getTime() > dto.term.finalDate
      ? dto.term.finalDate
      : new Date().getTime()
  );
  const [studentsToRegister, setStudentsToRegister] = useState([]);
  const [modal, setModal] = useState(false);
  const [singleShift, setSingleShift] = useState(false);
  const [studentsToUnEnrollment, setStudentsToUnEnrollment] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState({});
  const [stepsBySelectedCourse, setStepsBySelectedCourse] = useState([]);
  const [selectedStep, setSelectedStep] = useState({});
  const [showTimeTable, setShowTimeTable] = useState(false);
  const [term, setTerm] = useState();

  const onTermChange = (value) => {
    if (value) {
      loadStudentsToRelate(value);
      loadAllAcademicCalendar(value);
      const date =
        new Date().getTime() > value.finalDate
          ? value.finalDate
          : new Date().getTime();
      dispatch(change('SchoolClassForm', 'enrollmentDate', date));
      setInitialDateInMilli(date);
      setTerm(value);
    }
  };
  const toggleUnEnrollmentModal = () => {
    setModal(!modal);
  };

  const isShowTimeTable = () => {
    if (
      selectedClassShift &&
      selectedClassShift.id &&
      selectedStep &&
      selectedStep.id &&
      selectedAcademicCalendar &&
      selectedAcademicCalendar.id &&
      singleShift
    ) {
      setShowTimeTable(true);
    } else {
      setShowTimeTable(false);
    }
  };

  const changeSelectedClassShift = (value) => {
    setSelectedClassShift(value);
  };

  const changeSingleShift = (value) => {
    setSingleShift(value);
  };

  const changeAcademicCalendar = (value) => {
    setSelectedAcademicCalendar(value);
  };

  const changeSelectedStep = (value) => {
    setSelectedStep(value);
    dispatch(change('SchoolClassForm', 'courseStep', value));
  };

  const changeSelectedCourse = (value) => {
    setSelectedCourse(value);
    if (value) {
      const found = stepsByCourse.find((item) => item.courseId === value.id);
      let stepsFormatted = [];
      if (found) {
        const { steps } = found;
        if (steps.length) {
          stepsFormatted = steps.map((step) => ({
            ...step,
            value: step.id,
            label: step.fullName,
          }));
        }
      }
      setStepsBySelectedCourse(stepsFormatted);
      if (value.id !== selectedCourse.id) {
        dispatch(change('SchoolClassForm', 'courseStep', ''));
        setSelectedStep({});
      }
    } else {
      setStepsBySelectedCourse([]);
      setSelectedStep({});
      dispatch(change('SchoolClassForm', 'courseStep', ''));
    }
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).hidden =
        !copyProps.data.active;
    }
  };

  const removeEnrollmentItemClickHandler = (evt, rowData) => {
    toggleUnEnrollmentModal();
    setStudentsToUnEnrollment(rowData);
  };

  const UnEnrollmentStudents = () => {
    toggleUnEnrollmentModal();
    const updateRelationStudentClassList = [
      studentsToUnEnrollment,
      ...relationStudentClassList,
    ];
    changeRelationStudentClassList(updateRelationStudentClassList);

    const disabledStudent = {
      ...studentsToUnEnrollment,
      active: false,
      activeDescription: t('general.yesno.false'),
      finalDateInMilli: new Date().getTime(),
      finalDate: format(new Date(), 'dd/MM/yyyy'),
    };

    const copyStudents = registeredStudents;
    const index = copyStudents.indexOf(studentsToUnEnrollment);
    copyStudents[index] = disabledStudent;
    setRegisteredStudents(copyStudents);
    dispatch(change('SchoolClassForm', 'registeredStudents', copyStudents));
  };

  const addEnrollment = () => {
    const addStudentsToRegistered = [
      ...studentsToRegister,
      ...registeredStudents,
    ];
    setRegisteredStudents(addStudentsToRegistered);
    dispatch(
      change('SchoolClassForm', 'registeredStudents', addStudentsToRegistered)
    );
    dispatch(change('SchoolClassForm', 'SelectStudentsToRegister', ''));

    const updateStudentsToRegister = relationStudentClassList.filter(
      (record) =>
        studentsToRegister.findIndex(
          (toRemove) =>
            record.student.id === toRemove.student.id &&
            record.schoolShift.id === toRemove.schoolShift.id
        ) === -1
    );
    changeRelationStudentClassList(updateStudentsToRegister);
  };

  const onRegisteredStudentsChange = (students) => {
    if (students && students.length) {
      const mappedStudents = students.map((item) => ({
        ...item,
        initialDateInMilli,
        initialDate: format(new Date(initialDateInMilli), 'dd/MM/yyyy'),
        active: true,
        activeDescription: t('general.yesno.true'),
      }));
      setStudentsToRegister(mappedStudents);
    }
  };

  const onSelectedEnrollmentDate = (date) => {
    if (date) {
      setInitialDateInMilli(date.getTime());
      dispatch(change('SchoolClassForm', 'initialDateInMilli', date.getTime()));
      const mapDateInStudentsToRegister = studentsToRegister.map((item) => ({
        ...item,
        initialDateInMilli: date.getTime(),
        initialDate: format(new Date(date.getTime()), 'dd/MM/yyyy'),
        active: true,
        activeDescription: t('general.yesno.true'),
      }));
      setStudentsToRegister(mapDateInStudentsToRegister);
    }
  };

  const setValuesFiled = async () => {
    await changeSelectedCourse(dto.course);
    await changeSelectedStep(dto.courseStep);
    await changeAcademicCalendar(dto.academicCalendar);
    await changeSelectedClassShift(dto.classShift);
  };

  useEffect(() => {
    initialize(dto);
    if (dto.singleClassShift) {
      setSingleShift(dto.singleClassShift);
    }
    if (dto.id > 0) {
      setValuesFiled();
    }
    if (dto.term) {
      setTerm(dto.term);
    }
  }, [dto]);

  useEffect(() => {
    isShowTimeTable();
  }, [
    selectedStep,
    selectedClassShift,
    selectedCourse,
    singleShift,
    selectedAcademicCalendar,
  ]);

  return (
    <>
      <UnEnrollmentModal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleUnEnrollmentModal}
        modal={modal}
        onConfirm={UnEnrollmentStudents}
      />
      <form className="form" onSubmit={handleSubmit}>
        <div className="tabs tabs--justify tabs--bordered-bottom w-100">
          <div className="tabs__wrap">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === ACTIVE_TAB.ONE,
                  })}
                  onClick={() => {
                    toggleTab(ACTIVE_TAB.ONE);
                  }}
                >
                  {t('general.class-data')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === ACTIVE_TAB.TWO,
                  })}
                  onClick={() => {
                    toggleTab(ACTIVE_TAB.TWO);
                  }}
                  disabled={!showTimeTable}
                >
                  {t('general.distribution-classes')}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={ACTIVE_TAB.ONE} className="form">
                <div title={t('general.class-data')}>
                  <div className="form__form-group--3_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.school-term')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="term"
                          type="text"
                          isDisabled={registeredStudents.length}
                          component={Select}
                          options={schoolTerms}
                          onChange={onTermChange}
                          placeholder={t(
                            'placeholder.school-class.school-term'
                          )}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.course')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="course"
                          component={Select}
                          options={courses}
                          placeholder={t('general.placeholders.select')}
                          onChange={changeSelectedCourse}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.year-level')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="courseStep"
                          component={Select}
                          options={stepsBySelectedCourse}
                          placeholder={t('placeholder.school-class.year-level')}
                          onChange={changeSelectedStep}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group--3_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.name')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="name"
                          type="text"
                          component={renderField}
                          maxLength="200"
                          placeholder={t('placeholder.school-class.name')}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.short-name')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="shortName"
                          type="text"
                          component={renderField}
                          maxLength="50"
                          placeholder={t('placeholder.school-class.short-name')}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.capacity')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="capacity"
                          type="number"
                          component={renderField}
                          maxLength="3"
                          placeholder={t('placeholder.school-class.capacity')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group--3_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.academic-calendar')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="academicCalendar"
                          component={Select}
                          options={academicCalendars}
                          placeholder={t('general.placeholders.select')}
                          onChange={changeAcademicCalendar}
                        />
                      </div>
                    </div>
                    <div className="form__form-group d-flex align-items-end pb-2">
                      <div className="form__form-group-field pb-1">
                        <Field
                          name="singleClassShift"
                          component={renderCheckBoxField}
                          className="colored-click"
                          defaultChecked={singleShift}
                          onChange={(event) => {
                            if (event.target) {
                              changeSingleShift(event.target.checked);
                            }
                          }}
                        />
                        <Label className="generic__label">
                          {t('general.school-class-act-single-shift')}
                        </Label>
                      </div>
                    </div>
                    {singleShift && (
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('general.shift')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="classShift"
                            component={Select}
                            options={shifts}
                            placeholder={t('general.placeholders.select')}
                            onChange={changeSelectedClassShift}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="form__form-group--2_columns">
                    <div className="form__form-group">
                      <span className="form__form-group-label">{`${t(
                        'general.teacher'
                      )} 1`}</span>
                      <div className="form__form-group-field">
                        <Field
                          name="responsible"
                          type="text"
                          component={Select}
                          options={activeEmployeesList}
                          placeholder={t('placeholder.school-class.teacher-1')}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">{`${t(
                        'general.teacher'
                      )} 2`}</span>
                      <div className="form__form-group-field">
                        <Field
                          name="responsibleAux"
                          type="text"
                          component={Select}
                          options={activeEmployeesList}
                          placeholder={t('placeholder.school-class.teacher-2')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('general.team')}
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="team"
                        type="text"
                        component={Select}
                        isMulti
                        closeMenuOnSelect={false}
                        options={activeEmployeesList}
                        placeholder={t('placeholder.school-class.team')}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('general.registered-students')}
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="SelectStudentsToRegister"
                        type="text"
                        component={SelectVirtualized}
                        isMulti
                        closeMenuOnSelect={false}
                        options={
                          selectedClassShift && selectedClassShift.id
                            ? relationStudentClassList.filter(
                                (student) =>
                                  student.schoolShift.id ===
                                  selectedClassShift.id
                              )
                            : relationStudentClassList
                        }
                        placeholder={t(
                          'placeholder.school-class.registered-students'
                        )}
                        onChange={onRegisteredStudentsChange}
                      />
                    </div>
                  </div>
                  <div className="form__form-group--2_columns">
                    <div className="form__form-group col-md-2 mr-3">
                      <span className="form__form-group-label">
                        {t('general.enrollmentDate')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="enrollmentDate"
                          type="text"
                          onChange={onSelectedEnrollmentDate}
                          component={DateField}
                          selected={initialDateInMilli}
                          minDate={
                            term ? getDateWithoutTime(term.initialDate) : null
                          }
                          maxDate={
                            term ? getDateWithoutTime(term.finalDate) : null
                          }
                          placeholder={t('general.enrollmentDate')}
                        />
                      </div>
                    </div>
                    <div className="btn-form-group d-flex align-items-end">
                      <SmartButton
                        color="success"
                        label={t('general.add')}
                        onClick={addEnrollment}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <MaterialTable
                      data={registeredStudents}
                      columns={enrollmentsColumns(t)}
                      onRemoveClick={removeEnrollmentItemClickHandler}
                      deleteAction={removeEnrollmentItemClickHandler}
                      toolbar={false}
                      pageSize={10}
                      actionsDisabled
                      actionsDisabledByConditional={
                        actionsDisabledByConditional
                      }
                    />
                  </div>
                  <div className="form__form-group">
                    <div className="form__form-group-field">
                      <Label className="generic__label">
                        {t('general.active')}
                      </Label>
                      <Field
                        name="active"
                        component={renderCheckBoxField}
                        className="colored-click"
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={ACTIVE_TAB.TWO} className="form">
                {showTimeTable && (
                  <TimetableGrid
                    selectedClassShift={selectedClassShift}
                    selectedAcademicCalendar={selectedAcademicCalendar}
                    dispatch={dispatch}
                    disciplinesTimetable={disciplinesTimetable}
                    timetableGrid={timetableGrid}
                    timetable={timetable}
                    loadTimetableBySchoolClass={loadTimetableBySchoolClass}
                    selectedStep={selectedStep}
                    dto={dto}
                    setTimetableGrid={setTimetableGrid}
                  />
                )}
              </TabPane>
            </TabContent>
          </div>
        </div>
        <div className="form__form-group">
          <ButtonToolbar className="form__button-toolbar">
            <SmartButton
              color="primary"
              onClick={backHandler}
              label={t('general.back')}
            />
            <SmartButton
              color="success"
              type="submit"
              label={t('general.save')}
            />
          </ButtonToolbar>
        </div>
      </form>
    </>
  );
};

SchoolClassForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    active: PropTypes.bool,
    singleClassShift: PropTypes.bool,
    term: PropTypes.shape(PropTypes.shape),
    schoolGrade: PropTypes.shape(PropTypes.shape),
    responsible: PropTypes.shape(PropTypes.shape),
    responsibleAux: PropTypes.shape(PropTypes.shape),
    singleShift: PropTypes.bool,
    course: PropTypes.shape(PropTypes.shape),
    courseStep: PropTypes.shape(PropTypes.shape),
    classShift: PropTypes.shape(PropTypes.shape),
    academicCalendar: PropTypes.shape(PropTypes.shape),
  }).isRequired,
  schoolTerms: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  stepsByCourse: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  activeEmployeesList: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  relationStudentClassList: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  shifts: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  academicCalendars: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  loadStudentsToRelate: PropTypes.func.isRequired,
  changeRelationStudentClassList: PropTypes.func.isRequired,
  loadAllAcademicCalendar: PropTypes.func.isRequired,
  loadTimetableBySchoolClass: PropTypes.func.isRequired,
  toggleTab: PropTypes.func.isRequired,
  setRegisteredStudents: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  disciplinesTimetable: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  registeredStudents: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  timetable: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  setSelectedAcademicCalendar: PropTypes.func.isRequired,
  selectedAcademicCalendar: PropTypes.shape(PropTypes.shape),
  setSelectedClassShift: PropTypes.func.isRequired,
  selectedClassShift: PropTypes.shape(PropTypes.shape),
  timetableGrid: PropTypes.shape(PropTypes.shape),
  setTimetableGrid: PropTypes.func.isRequired,
};

SchoolClassForm.defaultProps = {
  disciplinesTimetable: [],
  timetable: [],
  selectedAcademicCalendar: {},
  selectedClassShift: {},
  timetableGrid: {},
};

export default reduxForm({
  form: 'SchoolClassForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(SchoolClassForm));
